import React from 'react';
import { connect } from 'react-redux';
import { cartItemInstructionsUpdate } from '../../../actions/cartItem';

class MenuItemInstructions extends React.Component {

    constructor(props) {
        super(props);

        this.onChangeInstructions = this.onChangeInstructions.bind(this);
    }

    onChangeInstructions(e) {
        this.props.dispatch(cartItemInstructionsUpdate(e.target.value))
    }

    render() {
        if (this.props.isOpen == "1") {
            return (
                <div>
                    <div className="choice-addon-wrapper special">
                        <textarea 
                            value={this.props.instructions}
                            className="textarea w-input"
                            onChange={this.onChangeInstructions}
                            placeholder={this.props.placeholder}
                        />
                    </div>
                </div>
            );
        }
        else {
            return <div />;
        }
    }
};

const mapStateToProps = (state) => {

    return {
        isOpen: state.currentLocation.info.location.open,
        instructions: state.cartItem.instructions
    };
};

export default connect(mapStateToProps)(MenuItemInstructions);